//1.
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Line } from "react-chartjs-2";
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// const USER_API = `${BaseUrl}CMN_07_Super/GET_USER_LIST`;
// const ANALYTIC_API = `${BaseUrl}CMN_09_Plant/DAILYSTS_ANALYTIC`;
// const WEB_KEY = "WEBXY2321";

// function getToday() {
//     const dt = new Date();
//     return dt.toISOString().split("T")[0];
// }

// function getLastWeek() {
//     const dt = new Date();
//     dt.setDate(dt.getDate() - 7);
//     return dt.toISOString().split("T")[0];
// }

// function formattedDate(str) {
//     if (!str) return "";
//     const [y, m, d] = str.split("-");
//     const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//     return `${d} ${months[parseInt(m, 10) - 1]} ${y}`;
// }

// function AnalyticsTab2() {
//     const [users, setUsers] = useState([]);
//     const [activeUsers, setActiveUsers] = useState([]); // controlled, but doesn't trigger data fetch by itself
//     const [dataByUser, setDataByUser] = useState({});
//     const [fromDate, setFromDate] = useState(getLastWeek());
//     const [toDate, setToDate] = useState(getToday());
//     const [idealValue, setIdealValue] = useState(13);
//     const [loading, setLoading] = useState(false);
//     const [fetchKey, setFetchKey] = useState(0);

//     // Fetch users and initial select all when refresh button is clicked (or on mount)
//     useEffect(() => {
//         setLoading(true);
//         axios.get(USER_API, {
//             params: {
//                 USER_ID: localStorage.getItem("LOGIN_ID"),
//                 Password: localStorage.getItem("PASSWORD"),
//                 SS_KEY: localStorage.getItem("SS_KEY"),
//             }
//         }).then(res => {
//             const usersData = res.data.data || [];
//             setUsers(usersData);
//             // Preserve previously checked users, otherwise select all (first load or if nothing checked)
//             setActiveUsers(au => au.length ? au : usersData.map(u => u.ID));
//             setLoading(false);
//         }).catch(() => setLoading(false));
//         // eslint-disable-next-line
//     }, [fetchKey]);

//     // Fetch analytics data ONLY when refresh button is clicked
//     useEffect(() => {
//         async function fetchAnalyticsData() {
//             setLoading(true);
//             let allSeries = {};
//             for (const u of users) {
//                 if (activeUsers.includes(u.ID)) {
//                     const form = new URLSearchParams({
//                         USER: u.ID,
//                         LCODE: u.loc_code,
//                         WEB_KEY,
//                         PASS_KEY: u.password,
//                         DT1: formattedDate(fromDate),
//                         DT2: formattedDate(toDate),
//                     });
//                     try {
//                         const res = await axios.post(ANALYTIC_API, form);
//                         allSeries[u.ID] = res.data.data || [];
//                     } catch {
//                         allSeries[u.ID] = [];
//                     }
//                 }
//             }
//             setDataByUser(allSeries);
//             setLoading(false);
//         }
//         if (users.length && activeUsers.length) {
//             fetchAnalyticsData();
//         } else {
//             setDataByUser({});
//         }
//         // eslint-disable-next-line
//     }, [fetchKey, users]); // Only on explicit refresh

//     // Remaining handlers just control UI
//     let mainLabels = [];
//     const firstActiveUserId = activeUsers.find(id => dataByUser[id]?.length);
//     if (firstActiveUserId) {
//         mainLabels = (dataByUser[firstActiveUserId] || []).map(d => d.DATET);
//     }
//     const datasets = [
//         {
//             label: "Ideal Value",
//             data: mainLabels.map(() => Number(idealValue)),
//             borderColor: "#305cff",
//             borderDash: [8, 4],
//             pointRadius: 0,
//             fill: false,
//             tension: 0,
//             borderWidth: 2,
//         },
//         ...users.filter(u => activeUsers.includes(u.ID)).map((u, idx) => ({
//             label: u.user_name,
//             data: (dataByUser[u.ID] || []).map(d => Number(d.CUF || 0)),
//             borderColor: [
//                 "#3069f6", "#0ca769", "#e3930a", "#cf4908",
//                 "#198d95", "#847999", "#484848", "#0177a5",
//                 "#ba68c8", "#f06292"
//             ][idx % 10],
//             fill: false,
//             tension: 0.24,
//             borderWidth: 2,
//         }))
//     ];

//     return (
//         <div style={{
//             background: "#fff",
//             borderRadius: 8,
//             boxShadow: "0 2px 8px #ddd",
//             padding: 18,
//             userSelect: 'none'
//         }}>
//             <h5 style={{ margin: "0 0 12px 0" }}>Plant Wise CUF Comparison</h5>
//             <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "5px", marginBottom: 12 }}>
//                 {users.map(u => (
//                     <label key={u.ID} style={{ marginRight: 12, fontSize: 13, whiteSpace: "nowrap", cursor: 'pointer' }}>
//                         <input
//                             type="checkbox"
//                             checked={activeUsers.includes(u.ID)}
//                             onChange={e => setActiveUsers(e.target.checked
//                                 ? [...activeUsers, u.ID]
//                                 : activeUsers.filter(id => id !== u.ID)
//                             )}
//                         />
//                         &nbsp;{u.user_name}
//                     </label>
//                 ))}
//             </div>
//             <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 14, margin: "10px 0 20px 0" }}>
//                 <label>Ideal Value</label>
//                 <input
//                     type="number"
//                     min="0"
//                     style={{ width: 50 }}
//                     value={idealValue}
//                     onChange={e => setIdealValue(e.target.value)}
//                 />
//                 <label>From Date</label>
//                 <input
//                     type="date"
//                     style={{ width: 130 }}
//                     value={fromDate}
//                     onChange={e => setFromDate(e.target.value)}
//                 />
//                 <label>To Date</label>
//                 <input
//                     type="date"
//                     style={{ width: 130 }}
//                     value={toDate}
//                     onChange={e => setToDate(e.target.value)}
//                 />

//                 <TbRefresh
//                     style={{ fontSize: "1.5rem", cursor: "pointer" }}
//                     onClick={() => setFetchKey(k => k + 1)}
//                     title="Refresh Chart"
//                 />
//             </div>
//             <div style={{ width: "100%", height: 370 }}>
//                 {loading ? (
//                     <div style={{ textAlign: "center", margin: "120px 0", color: "#999" }}>
//                         Loading...
//                     </div>
//                 ) : (
//                     mainLabels.length > 0 && datasets.length > 1 ? (
//                         <Line
//                             data={{ labels: mainLabels, datasets }}
//                             options={{
//                                 responsive: true,
//                                 maintainAspectRatio: false,
//                                 plugins: {
//                                     legend: { position: "top" },
//                                     title: { display: false },
//                                     tooltip: { mode: "index", intersect: false },
//                                 },
//                                 scales: {
//                                     x: { ticks: { font: { size: 13 } } },
//                                     y: { ticks: { font: { size: 13 } } }
//                                 },
//                             }}
//                         />
//                     ) : (
//                         <div style={{ textAlign: "center", margin: "120px 0", color: "#bbb" }}>
//                             No data to display.
//                         </div>
//                     )
//                 )}
//             </div>
//         </div>
//     );
// }

// export default AnalyticsTab2;

//2.

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { TbRefresh } from "react-icons/tb";
import { BaseUrl } from "../../../../../../api/AxiosApi";
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const USER_API = `${BaseUrl}CMN_07_Super/GET_USER_LIST`;
const ANALYTIC_API = `${BaseUrl}CMN_09_Plant/DAILYSTS_ANALYTIC`;
const WEB_KEY = "WEBXY2321";

function getToday() {
  const dt = new Date();
  return dt.toISOString().split("T")[0];
}
function getLastWeek() {
  const dt = new Date();
  dt.setDate(dt.getDate() - 7);
  return dt.toISOString().split("T")[0];
}
function formattedDate(str) {
  if (!str) return "";
  const [y, m, d] = str.split("-");
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${d} ${months[parseInt(m, 10) - 1]} ${y}`;
}

function AnalyticsTab2() {
  const [users, setUsers] = useState([]);
  const [activeUsers, setActiveUsers] = useState([]); // Start empty
  const [dataByUser, setDataByUser] = useState({});
  const [fromDate, setFromDate] = useState(getLastWeek());
  const [toDate, setToDate] = useState(getToday());
  const [idealValue, setIdealValue] = useState(20);
  const [loading, setLoading] = useState(false);
  const [fetchKey, setFetchKey] = useState(0);

  useEffect(() => {
    setLoading(true);
    axios.get(USER_API, {
      params: {
        USER_ID: localStorage.getItem("LOGIN_ID"),
        Password: localStorage.getItem("PASSWORD"),
        SS_KEY: localStorage.getItem("SS_KEY"),
      }
    }).then(res => {
      const usersData = res.data.data || [];
      setUsers(usersData);
      // Only first user checked by default if nothing set already:
      setActiveUsers(au => au.length ? au : usersData[0] ? [usersData[0].ID] : []);
      setLoading(false);
    }).catch(() => setLoading(false));
    // eslint-disable-next-line
  }, [fetchKey]);

  useEffect(() => {
    async function fetchAnalyticsData() {
      setLoading(true);
      let allSeries = {};
      for (const u of users) {
        if (activeUsers.includes(u.ID)) {
          const form = new URLSearchParams({
            USER: u.ID,
            LCODE: u.loc_code,
            WEB_KEY,
            PASS_KEY: u.password,
            DT1: formattedDate(fromDate),
            DT2: formattedDate(toDate),
          });
          try {
            const res = await axios.post(ANALYTIC_API, form);
            allSeries[u.ID] = res.data.data || [];
          } catch {
            allSeries[u.ID] = [];
          }
        }
      }
      setDataByUser(allSeries);
      setLoading(false);
    }
    if (users.length && activeUsers.length) {
      fetchAnalyticsData();
    } else {
      setDataByUser({});
    }
    // eslint-disable-next-line
  }, [fetchKey, users]);

  let mainLabels = [];
  const firstActiveUserId = activeUsers.find(id => dataByUser[id]?.length);
  if (firstActiveUserId) {
    mainLabels = (dataByUser[firstActiveUserId] || []).map(d => d.DATET);
  }
  const datasets = [
    {
      label: "Ideal Value",
      data: mainLabels.map(() => Number(idealValue)),
      borderColor: "#305cff",
      borderDash: [8, 4],
      pointRadius: 0,
      fill: false,
      tension: 0,
      borderWidth: 2,
    },
    ...users.filter(u => activeUsers.includes(u.ID)).map((u, idx) => ({
      label: u.user_name,
      data: (dataByUser[u.ID] || []).map(d => Number(d.CUF || 0)),
      borderColor: [
        "#3069f6", "#0ca769", "#e3930a", "#cf4908",
        "#198d95", "#847999", "#484848", "#0177a5",
        "#ba68c8", "#f06292"
      ][idx % 10],
      fill: false,
      tension: 0.24,
      borderWidth: 2,
    }))
  ];

  return (
    <div style={{
      background: "#fff",
      borderRadius: 8,
      boxShadow: "0 2px 8px #ddd",
      padding: 18,
      userSelect: 'none'
    }}>
      <h5 style={{ margin: "0 0 12px 0" }}>Plant Wise CUF Comparison</h5>
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "5px", marginBottom: 12 }}>
        {users.map(u => (
          <label key={u.ID} style={{ marginRight: 12, fontSize: 13, whiteSpace: "nowrap", cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={activeUsers.includes(u.ID)}
              onChange={e => setActiveUsers(e.target.checked
                ? [...activeUsers, u.ID]
                : activeUsers.filter(id => id !== u.ID)
              )}
            />
            &nbsp;{u.user_name}
          </label>
        ))}
      </div>
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 14, margin: "10px 0 20px 0" }}>
        <label>Ideal Value</label>
        <input
          type="number"
          min="0"
          style={{ width: 50 }}
          value={idealValue}
          onChange={e => setIdealValue(e.target.value)}
        />
        <label>From Date</label>
        <input
          type="date"
          style={{ width: 130 }}
          value={fromDate}
          onChange={e => setFromDate(e.target.value)}
        />
        <label>To Date</label>
        <input
          type="date"
          style={{ width: 130 }}
          value={toDate}
          onChange={e => setToDate(e.target.value)}
        />

        {/* <button
          style={{
            marginLeft: 18,
            fontSize: 17,
            cursor: "pointer",
            background: "#1976d2",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            padding: "5px 12px",
            display: "flex",
            alignItems: "center",
            transition: "background 0.2s"
          }}
          title="Refresh Chart"
          onClick={() => setFetchKey(k => k + 1)}
        >
          <TbRefresh style={{ fontSize: 22, marginRight: 4 }} /> Refresh
        </button> */}
        <TbRefresh
                            style={{ fontSize: "1.5rem", cursor: "pointer" }}
                            onClick={() => setFetchKey(k => k + 1)}
                            title="Refresh Chart"
                        />
      </div>
      <div style={{ width: "100%", height: 370 }}>
        {loading ? (
          <div style={{ textAlign: "center", margin: "120px 0", color: "#999" }}>
            Loading...
          </div>
        ) : (
          mainLabels.length > 0 && datasets.length > 1 ? (
            <Line
              data={{ labels: mainLabels, datasets }}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: { position: "top" },
                  title: { display: false },
                  tooltip: { mode: "index", intersect: false },
                },
                scales: {
                  x: { ticks: { font: { size: 13 } } },
                  y: { ticks: { font: { size: 13 } } }
                },
              }}
            />
          ) : (
            <div style={{ textAlign: "center", margin: "120px 0", color: "#bbb" }}>
              No data to display.
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default AnalyticsTab2;


